// src/config/index.js

// 1) Env (CRA: alleen REACT_APP_* komt mee naar de browser)
const envConfig = {
    keycloak: {
        url: process.env.REACT_APP_KEYCLOAK_URL,
        realm: process.env.REACT_APP_KEYCLOAK_REALM,
        clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
    },
    environment: process.env.REACT_APP_ENVIRONMENT,
    frontendUrl: process.env.REACT_APP_FRONTEND_URL,
    forgeBaseUrl: process.env.REACT_APP_FORGE_BASE_URL,
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    integrationApiBaseUrl: process.env.REACT_APP_NOCTIS_API_BASE_URL || process.env.REACT_APP_INTEGRATION_API_BASE_URL,
    noctisUiUrl: process.env.REACT_APP_NOCTIS_UI_URL,
    enableStrictMode:
        (process.env.REACT_APP_ENABLE_STRICT_MODE ?? "").toLowerCase() === "true",
};

// 2) Runtime (Kubernetes ConfigMap via Nginx)
const runtime =
    typeof window !== "undefined" && window.APP_CONFIG ? window.APP_CONFIG : null;

// 3) Kies: runtime ► env
const config = runtime ?? envConfig;

// 4) Guards (liefst falen met een duidelijke fout i.p.v. stiekem defaults)
const missing = [];
if (!config?.keycloak?.url) missing.push("keycloak.url");
if (!config?.keycloak?.realm) missing.push("keycloak.realm");
if (!config?.keycloak?.clientId) missing.push("keycloak.clientId");
if (!config?.frontendUrl) missing.push("frontendUrl");
if (!config?.apiBaseUrl) missing.push("apiBaseUrl");

if (missing.length) {
    // eslint-disable-next-line no-console
    console.error("Config missing keys:", missing, {
        APP_CONFIG: typeof window !== "undefined" ? window.APP_CONFIG : undefined,
        env: {
            REACT_APP_KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL,
            REACT_APP_KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM,
            REACT_APP_KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
            REACT_APP_FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL,
            REACT_APP_FORGE_BASE_URL: process.env.REACT_APP_FORGE_BASE_URL,
            REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
            REACT_APP_ENABLE_STRICT_MODE: process.env.REACT_APP_ENABLE_STRICT_MODE,
        },
    });
    throw new Error(
        `Frontend config incomplete: missing ${missing.join(
            ", "
        )}. Provide /config.js in prod or REACT_APP_* in .env for dev.`
    );
}

export default config;
